const noUser = async ({ next }) => {
  const auth = localStorage.getItem("_auth") ? JSON.parse(localStorage.getItem("_auth")) : null;

  if (
    auth &&
    auth.data &&
    auth.data.user_role &&
    auth.data.user_role.role &&
    auth.data.user_role.role.name === "user"
  ) {
    return next({ name: "wallet" });
  }

  return next();
};

export default noUser;
